import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Badge, Card, Group, Stack, Text, ThemeIcon, UnstyledButton } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import type { DealWithSide } from '@/lib/dashboard';
import { formatNotificationDate } from '@/lib/notificationView';
import { ROUTES } from '@/routes/paths';
import classes from './homeRow.module.css';
import { formatOrgName } from '@/lib/format';

interface NewDealsListProps {
  readonly deals: readonly DealWithSide[];
}

// Свежие сделки, начатые контрагентом по моим офферам/прайсам (информативно: ход сейчас не мой).
// Контрагент — противоположная сторона: для моей продажи это покупатель, для закупки — продавец.
export default function NewDealsList({ deals }: NewDealsListProps) {
  const { t } = useTranslation();

  return (
    <Card withBorder padding={0}>
      <Stack gap={0}>
        {deals.map(({ side, item }) => {
          const counterparty = side === 'SALE' ? item.buyer : item.seller;
          return (
            <UnstyledButton
              key={item.id}
              component={Link}
              to={`${ROUTES.APP_DEALS}/${item.id}`}
              className={classes.row}
            >
              <Group align="flex-start" wrap="nowrap" gap="sm">
                <ThemeIcon variant="light" color="lime.7" size="md" radius="xl">
                  <IconSparkles size={16} />
                </ThemeIcon>
                <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
                  <Group gap="xs" wrap="nowrap">
                    <Text fw={600} size="sm" truncate>
                      {item.goodsType ?? t('app.home.deal', { no: item.contractNum ?? `№${item.id}` })}
                    </Text>
                    <Badge color={side === 'SALE' ? 'brand' : 'lime'} variant="light" size="xs">
                      {t(side === 'SALE' ? 'app.home.newDeals.sold' : 'app.home.newDeals.bought')}
                    </Badge>
                  </Group>
                  <Text size="xs" c="gray.6" truncate>
                    {[formatOrgName(counterparty?.name), formatNotificationDate(item.createdDate)].filter(Boolean).join(' · ')}
                  </Text>
                </Stack>
              </Group>
            </UnstyledButton>
          );
        })}
      </Stack>
    </Card>
  );
}
